var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"table_box all_category inner"},[_c('div',{staticClass:"container flx"},[_c('div',{staticClass:"table_head flx"},[_c('span',{staticClass:"page_title"},[_vm._v("404 Страница не найдена")])])]),_c('div',{staticClass:"container"})])
}]

export { render, staticRenderFns }